import { render, staticRenderFns } from "./TreeVariablesFormulas.vue?vue&type=template&id=8c72ffa6&scoped=true&"
import script from "./TreeVariablesFormulas.vue?vue&type=script&lang=js&"
export * from "./TreeVariablesFormulas.vue?vue&type=script&lang=js&"
import style0 from "./TreeVariablesFormulas.vue?vue&type=style&index=0&id=8c72ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c72ffa6",
  null
  
)

export default component.exports